<div class="h-100 box d-flex flex-column px-2 pb-5 relative">
    <div class="px-4">
        <div class="text-l font-semi-bold border-b border-dark py-5">{{ 'v3-byoc-popup-create-course-title' | translate }}</div>
    </div>

    <div class="flex-grow-1">
        <div class="py-4 px-4 relative inner h-100">
            <div class="text-s font-semi-bold mb-4">{{ 'v3-byoc-popup-create-course-position-title' | translate }}</div>

            <div class="border border-dark rounded relative p-4">
                <ng-container *ngIf="loaded">
                    <div class="d-flex align-items-center mb-4">
                        <app-achievement-icon
                            class="icon icon-xxxl icon-achievement me-2"
                            [color]="mission.color"
                            [type]="mission.achievement.type"
                        ></app-achievement-icon>
                        <div class="text-s font-bold text-uppercase me-auto">{{ mission.name }}</div>
                        <a
                            [ariaLabel]="'v3-global-go-to-mission' | translate"
                            (enterKeyUp)="goToMission(mission.id)"
                            *ngIf="canOpenMission; else inactiveMissionLink"
                            [routerLink]="['/library', 'mission', mission.id]"
                            [target]="'_blank'"
                            class="icon icon-l icon-default pointer icon-hover-info pointer"
                            inlineSVG="assets/icons.svg#open-external"
                        ></a>
                        <ng-template #inactiveMissionLink>
                            <span #inactiveMissionLink class="icon icon-l icon-muted" inlineSVG="assets/icons.svg#open-external"></span>
                        </ng-template>
                    </div>

                    <div class="ps-6">
                        <app-byoc-course-step-position-list (loadedList)="listLoaded($event)" [mission]="mission"></app-byoc-course-step-position-list>
                    </div>
                </ng-container>

                <div *ngIf="!loaded" class="py-6">
                    <app-loader loaderType="cover" overlayColor="white"></app-loader>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex align-items-center px-4">
        <button (click)="cancelClick()" class="btn btn-secondary ms-auto" translate buttonDataTest="cancelButton">v3-button-cancel</button>
        <button (click)="backClick()" class="btn btn-secondary" translate buttonDataTest="backButton">v3-button-back</button>
        <button
            (click)="saveAndAddClick()"
            class="btn"
            [ngClass]="[loaded && loadedList ? 'btn-secondary' : 'btn-disabled']"
            translate
            buttonDataTest="saveAndAddButton"
        >
            v3-button-save-and-add-learning-item
        </button>
        <button (click)="saveClick()" class="btn" [ngClass]="[loaded && loadedList ? 'btn-primary' : 'btn-disabled']" translate buttonDataTest="saveButton">
            v3-button-save
        </button>
    </div>

    <app-loader *ngIf="saving" loaderType="cover" overlayColor="white"></app-loader>
</div>
